import { render, staticRenderFns } from "./weChartGroupList.vue?vue&type=template&id=2f32490e&scoped=true&"
import script from "./weChartGroupList.vue?vue&type=script&lang=js&"
export * from "./weChartGroupList.vue?vue&type=script&lang=js&"
import style0 from "./weChartGroupList.vue?vue&type=style&index=0&id=2f32490e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32490e",
  null
  
)

component.options.__file = "weChartGroupList.vue"
export default component.exports